import rateSummaryReducer, {RateSummaryState} from "./rateSummarySlice";
import ticketSummaryReducer, {ITicketSummaryState} from "./ticketSummarySlice";
import {configureStore, EnhancedStore} from "@reduxjs/toolkit";
import {useDispatch} from "react-redux";

interface IGlobalStore {
    ticketOwnerSummary: ITicketSummaryState;
    rateSummary: RateSummaryState;
}

export const store: EnhancedStore<IGlobalStore, any> = configureStore({
    reducer: {
        ticketOwnerSummary: ticketSummaryReducer,
        rateSummary: rateSummaryReducer,
    },
});

export type RootState = ReturnType<typeof store.getState>;
export type AppDispatch = typeof store.dispatch;
export const useAppDispatch = () => useDispatch<AppDispatch>();
